import React from "react";
import styles from "./userorderitem.module.css";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { useTranslation } from "react-i18next";

const OrderItem = ({
  brand,
  item,
  variation,
  quantity,
  price,
  status,
  deliveryStatus,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.orderItem}>
      <div className={styles.orderItemHeader}>
        <div className={styles.brand}>
          <StorefrontIcon sx={{ fontSize: 30 }} />
          <div>{brand}</div>
        </div>
        <button className={styles.shopButton}>
          <StorefrontIcon sx={{ fontSize: 20 }} />
          <span>{t("view_shop")}</span>
        </button>
        <div className={styles.orderStatus}>
          <div className={deliveryStatus !== "" ? styles.deliveryStatus : ""}>
            {deliveryStatus !== "" ? (
              <LocalShippingIcon sx={{ fontSize: 20 }} />
            ) : null}
            {deliveryStatus}
          </div>
          <div className={styles.status}>{status}</div>
        </div>
      </div>
      <div className={styles.orderItemBody}>
        <div className={styles.itemImage}></div>
        <div className={styles.itemInfo}>
          <div className={styles.itemName}>{item}</div>
          <div className={styles.itemSize}>
            {t("variation")}: {variation}
          </div>
          <div className={styles.itemQuantity}>x{quantity} </div>
        </div>
        <div className={styles.itemPrice}>₫{price}</div>
      </div>
      <div className={styles.orderItemFooter}>
        <div className={styles.totalPrice}>
          <span>{t("total_price")}:</span>
          <span className={styles.finalPrice}>₫{price}</span>
        </div>
        <div className={styles.buttonContainer}>
          <button className={styles.buyAgainButton}>{t("buy_again")}</button>
          <button className={styles.contactSellerButton}>
            {t("contact_seller")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderItem;
